import { createTheme } from '@mui/material';

import { primaryColor } from './colors';

export const theme = createTheme({
  cssVariables: {
    colorSchemeSelector: 'data-toolpad-color-scheme',
  },
  colorSchemes: {
    dark: {
      palette: {
        primary: {
          main: primaryColor,
        },
      },
    },
    light: {
      palette: {
        primary: {
          main: primaryColor,
        },
      },
    },
  },
  components: {
    MuiListItemButton: {
      styleOverrides: {
        root: {
          'html[data-toolpad-color-scheme="dark"] &.Mui-selected .MuiTypography-root':
            {
              color: '#fff',
            },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          'html[data-toolpad-color-scheme="dark"] &:-webkit-autofill': {
            caretColor: '#fff',
            WebkitTextFillColor: '#fff',
            WebkitBoxShadow: `0 0 0 100px #121212 inset !important`,
          },
          'html[data-toolpad-color-scheme="light"] &:-webkit-autofill': {
            caretColor: '#000000DC',
            WebkitTextFillColor: '#000000DC',
            WebkitBoxShadow: `0 0 0 100px #fff inset !important`,
          },
        },
      },
    },
  },
});
